import { createSlice } from "@reduxjs/toolkit";
import { clearSelectFeed } from "./actions";
const initialState = {
  liveFeedList: [],
  tagsList: [],
  selectedTag: "",
  selectedLiveFeed: "",
  isOpenCreateTagModal: false,
  isUpdateTagList: false,
};

const LiveFeedReducer = createSlice({
  name: "LiveFeedReducer",
  initialState: initialState,
  reducers: {
    setLiveFeedList: (state, { payload }) => {
      console.log("payload", payload);
      return {
        ...state,
        liveFeedList: payload,
        // isUpdateTagList: false,
      };
    },

    setSelectFeed: (state, { payload }) => {
      return {
        ...state,
        selectedLiveFeed: payload,
      };
    },

    openCreateTagModal: (state) => {
      return {
        ...state,
        isOpenCreateTagModal: true,
      };
    },

    updateTagsList: (state, { payload }) => {
      console.log("payload", payload);

      let newList = [...state.tagsList];
      console.log("newList", newList);
      for (let index = 0; index < newList.length; index++) {
        if (newList[index].tag_id === payload.tag_id) {
          newList[index] = payload;
        }
      }
      return {
        ...state,
        tagsList: newList,
      };
    },
    addList: (state, { payload }) => {
      console.log("payload", payload);
      let newList = [...state.tagsList];
      newList.push(payload);
      return {
        ...state,
        tagsList: newList,
        isUpdateTagList: true,
      };
    },

    closeCreateTagModal: (state) => {
      return {
        ...state,
        isOpenCreateTagModal: false,
      };
    },

    clearSelectItems: (state) => {
      return {
        ...state,
        selectedTag: "",
      };
    },
    clearSelectFeed: (state) => {
      return {
        ...state,
        selectedLiveFeed: "",
        selectedTag: "",
      };
    },
  },
});
export default LiveFeedReducer;
